import dayjs from "dayjs";
import { FacilityKind, FacilityType } from "../../../assets/data/Constants";
import { TkGetCode } from "../../../utils/TkGetCode";
import { changeAmountFormat } from "../../../utils/useTools";

function funPremiumFacilityBodyList(
  facilityList: any,
  year: number,
  setPremiumSum: any
) {
  let premiumSumAmount: number = 0;
  const facilityInfoBodyList = facilityList.map((facility: any) => {
    premiumSumAmount += facility.amt;
    const data = [
      {
        children:
          (facility.facilityNo ?? "") + ":" + (facility.facilityName ?? ""),
        forSort: facility.facilityNo,
      },
      {
        children:
          FacilityKind[facility.facilityKind as keyof typeof FacilityKind] ?? facility.facilityKind,
        forSort: facility.facilityKind,
      },
      {
        children: TkGetCode(FacilityType, facility.facilityKbn) ?? facility.facilityKbn,
        align: "center",
        forSort: facility.facilityKbn,
      },
      {
        children: changeAmountFormat(
          facility.premiumPaymentStaffNum ?? facility.premiumStaffNum
        ),
        align: "right",
        forSort: facility.premiumPaymentStaffNum ?? facility.premiumStaffNum,
      },
      {
        children: changeAmountFormat(facility.unitPremiumStaffNum),
        align: "right",
        width: "12%",
        forSort: facility.unitPremiumStaffNum,
      },
      {
        children: changeAmountFormat(facility.triplePremiumStaffNum),
        align: "right",
        width: "12%",
        forSort: facility.triplePremiumStaffNum,
      },
      {
        children: (year ?? "") + "年度",
        align: "center",
        forSort: year,
      },
      {
        children: changeAmountFormat(facility.amt),
        align: "right",
        width: "18%",
        forSort: facility.amt,
      },
    ];

    return data;
  });

  setPremiumSum(premiumSumAmount);
  return facilityInfoBodyList;
}

/**
 * ヘッダー作成
 * @param unitPremiumAmt 単位掛金額
 * @returns headList
 */
const makeHeadList = (unitPremiumAmt: number) => {
  const headList = [
    {
      headTitle: "施設名称",
    },
    {
      headTitle: "種類",
    },
    {
      headTitle: "区分",
    },
    {
      headTitle: "掛金納付対象職員数",
    },
    {
      headTitle: `「単位掛金額」対象職員数(単位金額:${changeAmountFormat(
        unitPremiumAmt
      )}円)`,
    },
    {
      headTitle: `「単位掛金額X3」対象職員数 (単位金額×${changeAmountFormat(
        unitPremiumAmt * 3
      )}円)	`,
    },
    {
      headTitle: "年度",
    },
    {
      headTitle: "掛金額",
    },
  ];

  return headList;
};

/**
 * 処理履歴を作成する
 * @param statusList
 * @returns statusBodyList
 */
function funStatusBodyList(statusList: any[]) {
  const statusBodyList: any[] = [];
  statusList.forEach((item: any) => {
    const data = [
      {
        children: item.managerName,
      },
      {
        children: item.process,
      },
      {
        children: dayjs(item.createDate).format("YYYY/MM/DD"),
      },
      {
        children: item.processComment,
      },
    ];
    statusBodyList.push(data);
  });

  return statusBodyList;
}

export { funStatusBodyList, funPremiumFacilityBodyList, makeHeadList };
